import useTypingEffect from "./TypingEffect";

const LiveWelcomeText = ({ textInput, setWelcomeTextCompleted }) => {
  const duration = 20;
  const isTypeByLetter = true;
  const textToShow = useTypingEffect(textInput, duration, isTypeByLetter);
  setTimeout(() => {
    if (textToShow === textInput) setWelcomeTextCompleted(true);
  }, 100);
  return (
    <section className="dss-welcome-text-section">
      <span className="dss-search-texting">{textToShow}</span>
      <div className="dss-search-texting-end" />
    </section>
  );
};

export default LiveWelcomeText;
